// src/i18n/withdraw.ts —— 06 agent-portal A-07 [新增 key] / [改写 key]；06 未给英文者标「本计划定稿」（待回写 06）
export const I18N_WITHDRAW = {
  zh: {
    withdrawNote: '提佣申请提交后由平台财务审核，USDT 审核通过后付款，通常当天到账，大额需双人复核可能更久；提到平台 USDT 钱包审核通过即实时到账，可直接用于开卡。', // [改写 key] D9；运营 UX 评审 #32 去掉「1 小时内」承诺
    inflightNote: '可提现佣金已扣除审核中、出金中、已到账及支付异常的提佣；支付异常的申请在平台处理完成前持续占用额度。', // [新增 key] R-04 / S-50
    stProcessing: '出金中', // [新增 key] S-50（approved / paying）
    stPayIssue: '支付异常，处理中', // [新增 key] S-50（failed）
    failedNote: '额度暂不释放', // [新增 key]
    netAmount: '实际到账', // [新增 key] M-04
    errAddrFmt: '仅支持 TRC20（TRON）地址：T 开头 34 位。不要填写 0x 开头的 ERC20 / BEP20 地址，转错网络无法找回。', // [新增 key]；运营 UX 评审 #33
    arriveUsdt: '审核后付款', // 运营 UX 评审 #32：原型「1 小时内」兑现不了（人工审核 + 大额复核）
    // 运营 UX 评审 2026-10-15 #14（P-17）：TRC20 未激活地址另收激活服务费，与 H5 wdActNote 同口径
    wdActNote: '收款地址未在 TRON 链上激活时，另收 {fee} USDT 激活服务费（平台未实际激活则付款后退回）。实际到账以记录为准。',
    wdActCharged: '含激活服务费 {fee} USDT',
    wdActConsumed: '含激活服务费 {fee} USDT（已用于激活）',
    wdActRefunded: '激活服务费 {fee} USDT 已退回',
    // 2026-10-15：提佣预检（服务端经 Tatum 读链判定收款地址激活状态），与 H5 wdActNeeded / wdActUnknown 同口径
    wdActNeeded: '该地址尚未激活，将另收激活费 {activation_fee} USDT（若平台无需代为激活，到账后退回），实际到账 {net} USDT',
    wdActUnknown: '暂时无法确认地址是否已激活，如需激活将另收 {fee} USDT',
  },
  en: {
    withdrawNote: 'Requests are reviewed by platform finance. USDT is paid after approval, usually the same day; large amounts need dual review and may take longer. The USDT wallet is credited instantly once approved and can be used to issue cards.',
    inflightNote: 'Withdrawable balance excludes requests under review, processing, paid or with a payment issue; a request with a payment issue keeps holding its amount until the platform resolves it.',
    stProcessing: 'Processing',
    stPayIssue: 'Payment issue, under review',
    failedNote: 'Amount stays on hold',
    netAmount: 'Net',
    errAddrFmt: 'TRC20 (TRON) only: starts with T, 34 chars. Do not use 0x (ERC20/BEP20) addresses — funds sent on the wrong network cannot be recovered.', // 本计划定稿
    arriveUsdt: 'Paid after review',
    wdActNote: "If the address is not yet activated on TRON, an extra {fee} USDT activation fee applies (refunded if we didn't activate it). See the record for the final amount.",
    wdActCharged: 'Includes {fee} USDT activation fee',
    wdActConsumed: 'Includes {fee} USDT activation fee (used)',
    wdActRefunded: '{fee} USDT activation fee refunded',
    wdActNeeded: 'This address is not activated yet. An activation fee of {activation_fee} USDT will be charged (refunded after payout if the platform does not need to activate it). You will receive {net} USDT.',
    wdActUnknown: 'We cannot confirm whether this address is activated right now. If activation is needed, an extra {fee} USDT will be charged.',
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值
export const REWRITES_WITHDRAW: readonly string[] = ['withdrawNote', 'arriveUsdt'];
